var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-carousel',{attrs:{"height":_vm.height}},[_c('ui-carousel-item',[_c('div',{staticClass:"slide-item",style:({
        height: _vm.height,
        backgroundImage: `url('${require('../assets/images/slides/slide.jpg')}')`,
      })})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }